'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { dealPath, imageLoader } from '@/utils';

interface IProps {
  name: string;
  iconPath: string;
  darkIconPath: string;
  active: boolean;
}

export default function MobileCategoryItem(props: IProps) {
  const { name, iconPath, darkIconPath, active } = props;
  return (
    <Link href={`/home/${dealPath(name)}/All/1`}>
      <div className={`w-[164px] h-20 px-3 shrink-0 flex items-center justify-center mr-[9px] rounded-xl ${active ? 'bg-[#0032B3]/5' : 'bg-[#FAFAFA]'}`}>
        <div className='w-[30px] h-[30px] shrink-0'>
          <Image style={{
            objectFit: 'contain',
          }} alt={name} src={active ? iconPath : darkIconPath } width={30} height={30} loader={imageLoader} />
        </div>
        <p className={`pl-2 font-medium text-14-19 ${active ? 'text-[#0032B3]' : ''}`}>{name}</p>
      </div>
    </Link>
  );
}
